@let result = settled$ | async;

@if (result !== 'done') {
  <div class="w-full h-full flex flex-row items-center justify-center">
    <p-progressSpinner ariaLabel="Processing payment"/>
  </div>
}
